export default class DragManager {
    constructor(scene, onDropFunc, onDragFunc){
        this.scene = scene;

        this.swipeDaggrablePosition = false // Si true : les cartes s'échange les zones, Si false : la carte revient à sa zone de départ
        this.keepZonePosition = true


        // Remove les anciens listener
        this.scene.input.removeListener('dragstart')
        this.scene.input.removeListener('drag')
        this.scene.input.removeListener('drop')
        this.scene.input.removeListener('dragend')

        // Fonctions basiques du drag&drop
        this.scene.input.on('dragstart', (pointer, gameObject) => {
            this.scene.children.bringToTop(gameObject);
            this.scene.input.setDefaultCursor('grabbing');
        });

        this.scene.input.on('drag', (pointer, gameObject, dragX, dragY) => {
            gameObject.x = dragX;
            gameObject.y = dragY;
            gameObject.setDepth(10)
        });

        this.scene.input.on('drop', (pointer, gameObject, dropZone) => {
            this.scene.input.setDefaultCursor('default')
            gameObject.drop(pointer, gameObject, dropZone)
        });
    
        this.scene.input.on('dragend', (pointer, gameObject, dropped) => {
            this.scene.input.setDefaultCursor('default')
            gameObject.dragEnd(pointer, gameObject, dropped)
        });

        this.scene.input.on('dragenter', (pointer, gameObject, dropZone) => {
            dropZone.onPointerOver()
        });

        this.scene.input.on('dragleave', (pointer, gameObject, dropZone) => {
            dropZone.onPointerOut()
        });
    }

    addDraggable(draggable, id, zone){
        draggable.setInteractive({useHandCursor: true});

        this.scene.input.setDraggable(draggable);

    }
    
    // drop(pointer, gameObject, dropZone){
    //     // Positionne l'élément au centre de la nouvelle zone
    //     gameObject.x = dropZone.x;
    //     gameObject.y = dropZone.y;
    //     gameObject.depth = dropZone.depth
    //     gameObject.setAngle(dropZone.angle)

    //     // Modif info de la zone
        

    //     this.onDropFunc(gameObject, dropZone)
    // }

    // dragEnd(pointer, gameObject, dropped){
    //     if (!dropped)
    //     {
    //         // On garde la position de la zone si on lache en déhors
    //         if(this.keepZonePosition){
    //             gameObject.x = gameObject.input.dragStartX;
    //             gameObject.y = gameObject.input.dragStartY;
    //         }else{
    //             // On reset la card à sa position initiale si on ne garde pas la position
    //             gameObject.resetPosition()
    //         }
    //     }
    // }

}